import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./NewDirectDebit.module.scss";
import NewSuccessIcon from "../../../assets/images/payment-success.png";
import { ArrowBack } from "@material-ui/icons";
import {
  closeLoader,
  openLoader,
} from "../../../redux/actions/loader/loaderActions";
import { Get, Post } from "../../../api/client";
import { useDispatch, useSelector } from "react-redux";
import { useTimerContext } from "../../../hooks/use-timer-context";
import { setTimeout } from "timers";
import CopyToClipboard from "react-copy-to-clipboard";
import { ContentCopy } from "@mui/icons-material";
import transactpay from "../../../assets/images/iconlogo.png";
import { commarize } from "../../../utils/helpers";
import { TrackOrderStatusAction } from "../../../redux/actions/orderStatus/orderStatusAction";
import { openToastAndSetContent } from "../../../redux/actions/toast/toastActions";
import { ToastErrorStyles } from "../../../constants/toastStyles";

interface NewDirectDebitProps {
  reference: string;
  address: string;
  goBackToDirectdebit: () => void;
  customerName: string;
}

type Bank = {
  name: string;
  value: string;
};

const NewDirectDebit: React.FC<NewDirectDebitProps> = ({
  reference,
  address,
  goBackToDirectdebit,
  customerName,
}) => {
  const [banks, setBanks] = useState<Bank[]>([]);
  const [selectedBank, setSelectedBank] = useState<string>("");
  const [accountNumber, setAccountNumber] = useState<string>("");
  const [step, setStep] = useState(1);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // proceed with payment states

  const [paymentStatus, setPaymentStatus] = useState<
    "idle" | "confirming" | "success" | "pending" | "timeout"
  >("idle");

  const [showTransferComponent, setShowTransferComponent] = useState(false);
  const [showOtpField, setShowOtpField] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isSettling, setIsSettling] = useState(false);
  const otpRef = useRef("");
  const [otp, setOtp] = useState("");

  useEffect(() => {
    otpRef.current = otp;
  }, [otp]);

  useEffect(() => {
    setOtp("");
  }, [showOtpField]);

  useEffect(() => {
    return () => {
      setPaymentStatus("idle");
    };
  }, []);

  const { orderDetails, virtualAccount } = useSelector(
    (state) => state.orderDetailsReducer,
  );
  const recurringPaymentId = orderDetails?.data?.order?.recurringPaymentId;
  const orderReference = orderDetails?.data?.order?.reference;
  const [mandateResponse, setmandateResponse] = useState<any>();
  const [isConfirming, setisConfirming] = useState(false);
  const [isTimeUp, setisTimeUp] = useState(false);

  // the actual transaction information
  const orderfee = useSelector((state) => state.orderFeeReducer);
  const fee: number = orderfee?.data?.customerFee ?? 0;
  const currency = orderDetails?.data?.order?.currency;
  const amount = orderDetails?.data?.isDiscounted
    ? orderDetails?.data?.newAmount
    : orderDetails?.data?.order?.amount;

  const [accountdetails, setAccountDetails] = useState(() => {
    if (virtualAccount && virtualAccount.reference === reference) {
      return {
        recipientAccount: virtualAccount.recipientAccount || "",
        expirytime: virtualAccount.expirytime || null,
        bankName: virtualAccount.bankName || "",
        accountName: virtualAccount.accountName || "",
      };
    }
    return {
      recipientAccount: "",
      expirytime: null,
      bankName: "",
      accountName: "",
    };
  });

  const bankName = accountdetails?.bankName;

  // const orderReference = orderDetails?.data?.order?.processorReference;
  const inFlight = useRef(false);

  const dispatch = useDispatch();

  //timer code
  const {
    timeRemainingInMinutesText,
    startTimer,
    timeRemainingInSeconds,
    hasTimerStarted,
    resetTimer,
  } = useTimerContext();

  const GetBanks = async () => {
    try {
      dispatch(openLoader("default"));
      const res: any = await Get("payment/banks?paymentmethod=transfer");
      const d: any[] = res?.data?.data || [];
      const banks: Bank[] = d.map((x) => ({
        name: x.name,
        value: x.bankCode,
      }));
      setBanks(banks);
      dispatch(closeLoader());
    } catch (err: any) {
      console.error(err);
      dispatch(closeLoader());
    }
  };

  const CreateMandate = async () => {
    try {
      dispatch(openLoader("default"));
      let payload: Record<string, unknown> = {
        // recurringPaymentId: recurringPaymentId ?? '',
        OrderReference: orderReference ?? "orderReference",
        bankName:
          banks.find((bank) => bank.value === selectedBank)?.name ?? "bankName",
        accountNumber: accountNumber ?? "accountNumber",
        bankCode:
          banks.find((bank) => bank.value === selectedBank)?.value ??
          "bankCode",
        address: address,
      };
      // console.log(payload);
      if (recurringPaymentId) {
        payload = { ...payload, recurringPaymentId: recurringPaymentId };
      }
      // console.log("mandate payload", payload);
      const res: any = await Post(
        "/payment/order/direct-debit/create",
        payload,
      );

      const data = res?.data;
      // console.log({ data });

      setmandateResponse(data);
      // console.log(res?.data);
      //call the timer after mandate response is gotten
      startTimer(900);
      // console.log("response from mandate", res.data);
      dispatch(closeLoader());
    } catch (err: any) {
      console.error(err);
      dispatch(closeLoader());
    }
  };

  useEffect(() => {
    GetBanks();

    return () => {
      resetTimer();
    };
  }, []);

  useEffect(() => {
    if (timeRemainingInSeconds < 0) {
      return;
    }

    //timer to go back once timer is over
    if (hasTimerStarted && timeRemainingInSeconds === 1 && step > 1) {
      //add something to indicate the timer has expired maybe a modal or something
      setisTimeUp(true);
      setTimeout(() => {
        setStep((st) => st - 1);
      }, 5000);
    }
  }, [step, hasTimerStarted, timeRemainingInSeconds]);

  const handleBankSelect = (bank: string) => {
    setSelectedBank(bank);
  };

  const handleAccountSubmit = () => {
    CreateMandate();
    setStep(2);
  };

  // confirm payment of mandate
  const handleConfirmPayment = useCallback(async () => {
    if (inFlight.current) return;
    inFlight.current = true;
    try {
      setisConfirming(true);
      // dispatch(openLoader("Checking Transaction Status", "transfer"));
      // dispatch(openLoader("default"));
      const res: any = await Get(
        `/payment/order/direct-debit/status?mandateCode=${mandateResponse?.data?.mandateCode}&orderReference=${orderReference}`,
      );
      if (res?.data?.status == true) {
        setShowSuccessModal(true); // Show the success modal on success
        setisConfirming(false);
      }
      // dispatch(closeLoader());
    } catch (err: any) {
      console.error(err);
      // dispatch(closeLoader());
    } finally {
      inFlight.current = false;
    }
  }, [dispatch, mandateResponse?.data?.mandateCode]);

  // check status /poll
  useEffect(() => {
    if (!isConfirming) {
      return;
    }
    dispatch(openLoader("Checking Transaction Status", "transfer"));
    const interval = setInterval(() => {
      handleConfirmPayment();
    }, 5000);
    return () => {
      clearInterval(interval);
      setisConfirming(false);
      dispatch(closeLoader());
    };
  }, [handleConfirmPayment, isConfirming]);

  const handleNext = () => {
    // setShowSuccessModal(false); // Close the modal
    // setShowTransferComponent(true);
    // sessionStorage.clear();
    // localStorage.clear();
    // window.location.reload();
    // goBackToDirectdebit();
    // window.open(window.location.href, "_top");
    sendOtpToUser();
  };

  const BackButton = () => (
    <button
      onClick={() => {
        if (step === 1) {
          goBackToDirectdebit();
          return;
        }
        if (step > 1) {
          setStep(step - 1);
        }
      }}
      className={styles.BackButton}
    >
      <ArrowBack style={{ marginRight: "5px", fontSize: "18px" }} />
      Back
    </button>
  );

  // copy values
  const [copied, setCopied] = useState(false);
  if (copied) {
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  }
  const [amountCopied, setamountCopied] = useState(false);
  if (amountCopied) {
    setTimeout(() => {
      setamountCopied(false);
    }, 2000);
  }

  // request an OTP for the mandate we just authorised, then show the OTP field

  const sendOtpToUser = async () => {
    try {
      setIsSendingOtp(true);
      dispatch(openLoader("default"));
      const payload = { mandateCode: mandateResponse?.data?.mandateCode };
      const res: any = await Post("/payment/order/direct-debit/otp", payload);
      dispatch(closeLoader());
      if (res?.data?.code == "00") {
        setShowSuccessModal(false);
        setShowTransferComponent(false);
        setShowOtpField(true);
      }
    } catch (error: any) {
      dispatch(closeLoader());
      const errorMessage =
        error?.response?.data?.Message || error?.response?.data?.message;
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: errorMessage,
        }),
      );
    } finally {
      setIsSendingOtp(false);
    }
  };
  // final settlement call — now carries the OTP the backend requires
  const settleOrderPayment = async () => {
    const currentOtp = otpRef.current;
    try {
      setIsSettling(true);
      dispatch(openLoader("default"));
      const payload: Record<string, unknown> = {
        paymentOption: "ndd",
        reference,
        directDebitPaymentRequest: {
          accountName: customerName ?? "",
          bankCode: mandateResponse?.data?.bankCode ?? "",
          mandateCode: mandateResponse?.data?.mandateCode ?? "",
          otp: currentOtp,
        },
      };
      const res: any = await Post("/payment/order/pay", payload);
      const responseCode = res?.data?.orderPayment?.orderPaymentResponseCode;

      setShowOtpField(false);
      setIsSettling(false);

      if (responseCode === "00") {
        dispatch(closeLoader());
        setPaymentStatus("success");
        return;
      }

      // "01" Initiated, or anything non-terminal — hand off to polling.
      // TrackOrderStatusAction owns its own loader from here; don't close it below.
      setPaymentStatus("confirming");
      TrackOrderStatusAction(
        { reference, paymentOption: "ndd" },
        "directDebit",
        dispatch,
        (cbdata: any) => {
          if (cbdata?.status === "completed") {
            setPaymentStatus("success");
          } else if (cbdata?.status === "time-out") {
            setPaymentStatus("timeout");
          }
          dispatch(closeLoader());
        },
      );
    } catch (error: any) {
      dispatch(closeLoader());
      setIsSettling(false);
      const errorMessage =
        error?.response?.data?.Message || error?.response?.data?.message;
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: errorMessage,
        }),
      );
    }
  };
  // const settleOrderPayment = async () => {
  //   const currentOtp = otpRef.current;
  //   try {
  //     setIsSettling(true);
  //     dispatch(openLoader("default"));
  //     const payload: Record<string, unknown> = {
  //       paymentOption: "ndd",
  //       reference: reference,
  //       directDebitPaymentRequest: {
  //         accountName: customerName ?? "",
  //         bankCode: mandateResponse?.data?.bankCode ?? "",
  //         mandateCode: mandateResponse?.data?.mandateCode ?? "",
  //         otp: currentOtp,
  //       },
  //     };
  //     const res: any = await Post("/payment/order/pay", payload);

  //     console.log("PAY RESPONSE:", res);
  //     console.log("PAY STATUS:", res?.status);
  //     console.log("PAY STATUS CODE:", res?.statusCode);

  //     if (res?.status === "success" || res?.statusCode === "02") {
  //       TrackOrderStatusAction(
  //         { reference, paymentOption: "ndd" },
  //         "directDebit",
  //         dispatch,
  //         () => {},
  //       );
  //       setShowOtpField(false);
  //       // window.open(window.location.href, "_top");
  //     }
  //   } catch (error: any) {
  //     const errorMessage =
  //       error?.response?.data?.Message || error?.response?.data?.message;
  //     dispatch(
  //       openToastAndSetContent({
  //         toastStyles: ToastErrorStyles,
  //         toastContent: errorMessage,
  //       }),
  //     );
  //   } finally {
  //     dispatch(closeLoader());
  //     setIsSettling(false);
  //   }
  // };

  const handleOtpChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (value.length > 1) {
      const trimmed = value.slice(0, 6);
      setOtp(trimmed);
      const inputs = document.querySelectorAll<HTMLInputElement>(
        `.${styles.otpInput}`,
      );
      inputs[Math.min(trimmed.length - 1, 5)]?.focus();
      return;
    }
    const newOtp = otp.split("");
    newOtp[index] = value || "";
    setOtp(newOtp.join(""));
  };

  const handleOtpKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    if (e.key === "Backspace") {
      let newOtp = otp.split("");
      newOtp[index] = "";
      setOtp(newOtp.join(""));
      if (!otp[index] && e.currentTarget.previousElementSibling) {
        (e.currentTarget.previousElementSibling as HTMLInputElement).focus();
      }
    }
  };

  const handleOtpKeyUp = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    const value = (e.target as HTMLInputElement).value.replace(/[^0-9]/g, "");
    if (value && index < 5) {
      const inputs = document.querySelectorAll<HTMLInputElement>(
        `.${styles.otpInput}`,
      );
      inputs[index + 1]?.focus();
    }
  };

  const handleOtpPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pastedValue = e.clipboardData.getData("text").replace(/[^0-9]/g, "");
    const newOtp = pastedValue.slice(0, 6);
    setOtp(newOtp);
    const inputs = document.querySelectorAll<HTMLInputElement>(
      `.${styles.otpInput}`,
    );
    inputs.forEach((input, idx) => {
      input.value = newOtp[idx] || "";
    });
    if (inputs[newOtp.length - 1]) {
      inputs[newOtp.length - 1].focus();
    }
  };

  const handleOtpSubmit = () => {
    if (otpRef.current.trim().length < 6) return;
    settleOrderPayment();
  };

  return (
    <div className={styles.container}>
      {!showTransferComponent && (
        <>
          <BackButton />
          {step === 1 && (
            <div className={styles.stepContainer}>
              <h3>Link bank account</h3>

              <div className={styles.formGroup}>
                <div style={{ marginBottom: "20px" }}>
                  <label htmlFor="bank">Select your bank provider</label>
                  <select
                    id="bank"
                    className={styles.dropdown}
                    value={selectedBank}
                    onChange={(e) => handleBankSelect(e.target.value)}
                  >
                    <option value="">Select bank</option>
                    {banks.map((bank) => (
                      <option key={bank.name} value={bank.value}>
                        {bank.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div style={{ marginBottom: "20px" }}>
                  <label htmlFor="accountNumber">Enter account number</label>
                  <input
                    id="accountNumber"
                    type="text"
                    className={styles.input}
                    value={accountNumber}
                    onChange={(e) => setAccountNumber(e.target.value)}
                    placeholder="Enter your account number"
                  />
                </div>
              </div>

              <button
                className={styles.button}
                onClick={handleAccountSubmit}
                disabled={!accountNumber}
              >
                Link account
              </button>

              {/* Powered by */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div className={styles.poweredByBox}>
                  <p className={styles.poweredBy}>Powered by</p>
                  <img
                    src={transactpay}
                    style={{
                      width: "auto",
                      height: "20px",
                      objectFit: "cover",
                    }}
                    alt="Transactpay"
                  />
                </div>
              </div>
            </div>
          )}

          {step === 2 && !showOtpField && (
            <>
              <div className={styles.stepContainer}>
                {/* new design */}
                <div className={styles.transferbodycontainer}>
                  <span
                    className={styles.separatetextbox}
                    style={{ color: "#8E173E" }}
                  >
                    Please transfer the exact amount shown to avoid rejection.
                  </span>
                  <div className={styles.transferbody}>
                    {/* amount start */}
                    <div className={styles.detailsWrapper}>
                      <div className={styles.account_label_text_Box}>
                        <p className={styles.account_label}>Amount</p>
                      </div>
                      <span className={styles.AmountNumber}>
                        {/* {currency ?? "NGN"} {commarize(Number(amount) + fee)} */}
                        NGN {mandateResponse?.data?.amount}
                        <CopyToClipboard
                          text={mandateResponse?.data?.amount}
                          onCopy={() => setamountCopied(true)}
                        >
                          <span className={styles.copy}>
                            {amountCopied ? (
                              "Copied!"
                            ) : (
                              <>
                                <ContentCopy style={{ height: "17px" }} />
                              </>
                            )}
                          </span>
                        </CopyToClipboard>
                      </span>
                    </div>
                    {/* amount end */}
                    <div className={styles.detailsWrapper}>
                      <p className={styles.account_label}>Account Number</p>
                      <span className={styles.accountNumber}>
                        {mandateResponse?.data?.accountNumber}
                        <CopyToClipboard
                          text={mandateResponse?.data?.accountNumber}
                          onCopy={() => setCopied(true)}
                        >
                          <span className={styles.copy}>
                            {copied ? (
                              "Copied!"
                            ) : (
                              <>
                                <ContentCopy style={{ height: "17px" }} />
                              </>
                            )}
                          </span>
                        </CopyToClipboard>
                      </span>
                    </div>
                    <div className={styles.detailsWrapper}>
                      <div className={styles.bankName}>
                        <p className={styles.account_label}>Bank Name</p>
                        <p style={{ fontWeight: "bolder" }}>
                          {" "}
                          {mandateResponse?.data?.bankName}
                          {/* Moniepoint MFB */}
                        </p>
                      </div>
                      <div className={styles.bankBeneficiary}>
                        <p className={styles.account_label}>Beneficiary</p>
                        <p style={{ fontWeight: "bolder" }}>
                          Transact Pay Direct Debit
                        </p>
                      </div>
                    </div>
                  </div>
                  <span className={styles.separatetextbox}>
                    Account details is valid for this transaction only and it
                    will expire in{" "}
                    <strong>{timeRemainingInMinutesText} minutes</strong>.
                  </span>
                </div>
                {/* new design*/}
                <button
                  className={styles.button}
                  onClick={handleConfirmPayment}
                >
                  I have sent the money
                </button>
              </div>
            </>
          )}
        </>
      )}
      {/* Success Modal */}
      {showSuccessModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <img src={NewSuccessIcon} />
            <h3 className={styles.modalTitle}>
              Mandate Authorised Successfully
            </h3>
            <button
              className={styles.modalButton}
              onClick={handleNext}
              disabled={isSendingOtp}
            >
              {isSendingOtp ? "Sending code..." : "Next"}
            </button>
          </div>
        </div>
      )}
      {showTransferComponent && (
        <div className={styles.stepContainer}>
          {/* new design */}
          <div className={styles.transferbodycontainer}>
            <span
              className={styles.separatetextbox}
              style={{ color: "#8E173E" }}
            >
              Please transfer the exact amount shown to avoid rejection.
            </span>
            <div className={styles.transferbody}>
              {/* amount start */}
              <div className={styles.detailsWrapper}>
                <div className={styles.account_label_text_Box}>
                  <p className={styles.account_label}>Amount</p>
                </div>
                <span className={styles.AmountNumber}>
                  {currency ?? "NGN"}{" "}
                  {commarize((Number(amount) + fee).toFixed(10))}
                  <CopyToClipboard
                    text={`${commarize((Number(amount) + fee).toFixed(10))}`}
                    onCopy={() => setamountCopied(true)}
                  >
                    <span className={styles.copy}>
                      {amountCopied ? (
                        "Copied!"
                      ) : (
                        <ContentCopy style={{ height: "17px" }} />
                      )}
                    </span>
                  </CopyToClipboard>
                </span>
              </div>
              {/* amount end */}
              <div className={styles.detailsWrapper}>
                <p className={styles.account_label}>Account Number</p>
                <span className={styles.accountNumber}>
                  {accountdetails?.recipientAccount ?? "00000000000"}
                  <CopyToClipboard
                    text={accountdetails?.recipientAccount}
                    onCopy={() => setCopied(true)}
                  >
                    <span className={styles.copy}>
                      {copied ? (
                        "Copied!"
                      ) : (
                        <ContentCopy style={{ height: "17px" }} />
                      )}
                    </span>
                  </CopyToClipboard>
                </span>
              </div>
              <div className={styles.detailsWrapper}>
                <div className={styles.bankName}>
                  <p className={styles.account_label}>Bank Name</p>
                  <p style={{ fontWeight: "bolder" }}>
                    {bankName ?? "Wema Bank"}
                  </p>
                </div>
                {/* <div className={styles.bankBeneficiary}>
                  <p className={styles.account_label}>Beneficiary</p>
                  <p style={{ fontWeight: "bolder" }}>
                    Transact Pay Direct Debit
                  </p>
                </div> */}
              </div>
            </div>
            <span className={styles.separatetextbox}>
              Account details is valid for this transaction only and it will
              expire in <strong>{timeRemainingInMinutesText} minutes</strong>.
            </span>
          </div>
          {/* new design*/}
          <button className={styles.button} onClick={handleConfirmPayment}>
            I have sent the money
          </button>
        </div>
      )}
      {/* OTP Input Field */}
      {showOtpField && (
        <div className={styles.otpContainer}>
          <h5 style={{ fontWeight: 600 }}>Enter the OTP to complete payment</h5>
          <p>
            We've sent a one-time code to verify this payment. Enter it below to
            finish.
          </p>
          <div className={styles.secondarySelectionContainer}>
            <div className={styles.otpInputContainer}>
              {Array(6)
                .fill("")
                .map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    inputMode="numeric"
                    maxLength={6}
                    autoComplete={index === 0 ? "one-time-code" : "off"}
                    pattern="[0-9]*"
                    className={styles.otpInput}
                    value={otp[index] || ""}
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleOtpKeyDown(e, index)}
                    onKeyUp={(e) => handleOtpKeyUp(e, index)}
                    onPaste={handleOtpPaste}
                  />
                ))}
            </div>
          </div>
          <button
            type="button"
            disabled={otp.trim().length < 6 || isSettling}
            className={styles.submitButton}
            onClick={handleOtpSubmit}
          >
            {isSettling ? "Processing..." : "Pay"}
          </button>
        </div>
      )}
      {/* Confirming payment — settle call returned non-final code, polling now */}
      {paymentStatus === "confirming" && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <h3 className={styles.modalTitle}>Checking payment status</h3>
            <p>Please wait while we confirm your payment...</p>
          </div>
        </div>
      )}

      {/* Payment confirmed successful */}
      {paymentStatus === "success" && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <img src={NewSuccessIcon} />
            <h3 className={styles.modalTitle}>Payment Successful</h3>
            <button
              className={styles.modalButton}
              onClick={goBackToDirectdebit}
            >
              Done
            </button>
          </div>
        </div>
      )}

      {/* Couldn't confirm in time */}
      {paymentStatus === "timeout" && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <h3 className={styles.modalTitle}>Still Processing</h3>
            <p>
              We couldn't confirm your payment in time. Please check your
              transaction status shortly.
            </p>
            <button
              className={styles.modalButton}
              onClick={goBackToDirectdebit}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Time up modal */}
      {/* {isTimeUp && (
        <Modal>
          <div>
            <p>The account number has expired, kindly retry </p>
            <button onClick={() => setStep(step - 1)}>Retry</button>
          </div>
        </Modal>
      )} */}
    </div>
  );
};

export default NewDirectDebit;
